<template>
  <div class="background">
    <a-card class="card" :title="ProjectName">
      <div style="text-align: center; padding-top: 16px">
        <!-- ✅ 圆形容器包住 logo，带悬浮效果 -->
        <div class="logo-wrapper" @click="jump_login">
          <img :src="logo" class="logo-img" alt="logo" />
        </div>
      </div>

      <div class="start-btn-wrapper">
        <a-button
          @click="jump_login"
          type="primary"
          size="large"
          class="start-btn"
        >
          立即开始
        </a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
export default {
  name: 'Yindao',
  data() {
    return {
      logo: require('@/assets/logo.png'),
      // ✅ 补上项目名称，避免 :title="ProjectName" 报 undefined
      ProjectName: process.env.VUE_APP_PROJECT_NAME || '中暨大厦物业管理系统'
    }
  },
  methods: {
    jump_login() {
      this.$router.push('/user/login')
    }
  }
}
</script>

<style scoped>
.card {
  width: 450px;
  border-radius: 8px;
  padding-bottom: 64px;
  margin: auto;
}

.background {
  min-height: 100%;
  padding: 10vh 0;
  background: url('https://pic2.ziyuan.wang/user/tanfuhua/2024/08/v2-e2d0fa9819c540732a4e7e980d5b48a9_r_26ba0cd0fea17.jpg');
  background-size: 100% 100%;
}

.title {
  text-align: center;
  font-size: 32px;
  color: #1890ff;
  margin-top: 8px;
  font-weight: bold;
}

/* ✅ 圆形 logo 容器 + 悬浮效果 */
.logo-wrapper {
  width: 120px;
  height: 120px;
  margin: 16px auto 0;
  border-radius: 50%;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

/* 悬浮时轻微上浮 + 放大 + 阴影增强 */
.logo-wrapper:hover {
  transform: translateY(-4px) scale(1.05);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

/* ✅ 图片完全填充圆形区域（方图被裁成圆形） */
.logo-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

/* 按钮外层容器：加大和 logo 之间的间距 */
.start-btn-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 40px;      /* ✅ 往下移一些，和 logo 拉开距离 */
  margin-bottom: 40px;
}

/* 酷一点的按钮样式：圆角、渐变、阴影、悬浮动画 */
.start-btn {
  width: 220px;
  height: 44px;
  border-radius: 999px;                    /* 胶囊形状 */
  border: none;
  background: linear-gradient(135deg, #50799e, #1890ff);
  background-size: 200% 200%;
  color: #fff;
  font-size: 16px;
  letter-spacing: 2px;
  font-weight: 500;

  box-shadow: 0 4px 12px rgba(80, 121, 158, 0.5);
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    background-position 0.25s ease;
}

/* hover/聚焦时的动效：轻微上浮 + 放大 + 阴影变强 + 渐变动起来 */
.start-btn:hover,
.start-btn:focus {
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 8px 20px rgba(80, 121, 158, 0.75);
  background-position: 100% 50%;
}

/* 按下的压感 */
.start-btn:active {
  transform: translateY(-1px) scale(0.99);
  box-shadow: 0 4px 10px rgba(80, 121, 158, 0.6);
}

</style>
